<!-- components/chatbot/chatbot.component.html -->
<div class="h-full w-full flex flex-col">
  <div class="bg-white flex-1 flex flex-col overflow-hidden">
    <!-- Header -->
    <div class="bg-lala-red px-3 sm:px-6 py-3 sm:py-4 shadow-md">
      <div class="flex items-center justify-between">
        <div class="flex items-center space-x-2 sm:space-x-4">
          <div class="p-1.5 sm:p-2 bg-white rounded-xl shadow-inner">
            <img
              src="assets/images/lala-logo.png"
              alt="Lala"
              class="h-6 sm:h-8 w-auto"
            />
          </div>
          <div>
            <h1 class="text-base sm:text-lg md:text-2xl font-bold text-white">
              Políticas Lala
            </h1>
            <p
              class="text-red-50 mt-0.5 sm:mt-1 text-xs sm:text-sm opacity-90 hidden sm:block"
            >
              Consultas corporativas con Inteligencia Artificial
            </p>
          </div>
        </div>
        <div class="flex items-center space-x-2 sm:space-x-4">
          <!-- Botón Limpiar Chat -->
          <button
            *ngIf="chatHistory.messages.length > 0"
            class="bg-white bg-opacity-20 hover:bg-opacity-30 text-white px-2 sm:px-3 py-1 sm:py-1.5 rounded-lg text-xs sm:text-sm font-medium transition-colors duration-200"
            (click)="clearChat()"
          >
            <span class="sm:hidden">Limpiar</span>
            <span class="hidden sm:inline">Limpiar Chat</span>
          </button>

          <!-- Indicador En línea -->
          <div class="flex items-center space-x-1 sm:space-x-2">
            <div class="w-2 h-2 bg-green-400 rounded-full animate-pulse"></div>
            <span
              class="text-xs sm:text-sm text-white opacity-90 hidden sm:inline"
              >En línea</span
            >
          </div>

          <!-- 👤 Menú de usuario -->
          <div class="relative">
            <button
              (click)="toggleUserMenu()"
              class="flex items-center space-x-2 text-white hover:bg-white hover:bg-opacity-10 px-2 py-1.5 rounded-lg transition-colors duration-200"
            >
              <div
                class="w-8 h-8 bg-white bg-opacity-20 rounded-full flex items-center justify-center border border-white border-opacity-30"
              >
                <span class="text-white font-medium text-sm">{{
                  getUserInitials()
                }}</span>
              </div>
              <svg
                class="w-4 h-4 text-white opacity-80"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M19 9l-7 7-7-7"
                ></path>
              </svg>
            </button>

            <!-- Dropdown menu -->
            <div
              *ngIf="showUserMenu"
              class="absolute right-0 mt-2 w-56 sm:w-64 bg-white rounded-lg shadow-xl py-1 z-50 border border-gray-100"
              (mouseleave)="closeUserMenu()"
            >
              <div
                class="px-4 py-3 text-sm text-gray-600 border-b border-gray-100 bg-gray-50 truncate"
              >
                <span class="block text-xs text-gray-400 mb-1"
                  >Conectado como</span
                >
                {{ getUserEmail() }}
              </div>
              <button
                (click)="onSignOut()"
                class="flex items-center w-full text-left px-4 py-3 text-sm text-gray-700 hover:bg-gray-50 transition-colors duration-150"
              >
                <svg
                  class="w-4 h-4 mr-3 text-gray-400"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
                  ></path>
                </svg>
                Cerrar Sesión
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Chat Messages -->
    <div class="flex-1 overflow-y-auto p-6 space-y-4" #messagesContainer>
      <!-- Welcome Message -->
      <div *ngIf="chatHistory.messages.length === 0" class="text-center py-8">
        <div
          class="w-20 h-20 bg-white rounded-2xl flex items-center justify-center mx-auto mb-6 shadow-xl border border-gray-100"
        >
          <img
            src="assets/images/lala-logo.png"
            alt="Grupo LALA"
            class="h-14 w-auto"
          />
        </div>
        <h3 class="text-2xl font-bold text-gray-900 mb-2">
          ¡Bienvenido a tu Agente de Políticas Lala!
        </h3>
        <p class="text-lg text-gray-600 mb-8 max-w-2xl mx-auto">
          Tu asistente inteligente para consultar normativas, procedimientos y
          políticas vigentes de Grupo Lala de forma rápida y sencilla.
        </p>

        <!-- 🚀 PREGUNTAS SUGERIDAS MEJORADAS -->
        <div class="max-w-3xl mx-auto">
          <h4 class="text-sm font-medium text-gray-700 mb-3">
            Consultas sugeridas:
          </h4>
          <div class="grid grid-cols-1 md:grid-cols-2 gap-3">
            <button
              *ngFor="let question of suggestedQuestions"
              class="text-left p-3 bg-gray-50 hover:bg-gray-100 rounded-lg border border-gray-200 hover:border-lala-red transition-colors duration-200"
              (click)="sendSuggestedQuestion(question)"
            >
              <span class="text-sm text-gray-700">{{ question }}</span>
            </button>
          </div>
        </div>
      </div>

      <!-- Chat Messages -->
      <div
        *ngFor="let message of chatHistory.messages; let i = index"
        class="space-y-4"
      >
        <!-- User Message -->
        <div class="flex justify-end">
          <div
            class="max-w-5xl bg-lala-red text-white rounded-2xl px-4 py-3 shadow-md"
          >
            <p class="text-sm">{{ message.user_message }}</p>
            <span class="text-xs text-white mt-1 block">{{
              message.timestamp | date: "short"
            }}</span>
          </div>
        </div>

        <!-- Bot Response -->
        <div class="flex justify-start" *ngIf="shouldShowBotBubble(message, i)">
          <div class="max-w-6xl bg-gray-100 rounded-2xl px-4 py-3 shadow-md">
            <!-- Loading State - Indicador "escribiendo..." -->
            <div
              *ngIf="isMessageLoading(i)"
              class="flex items-center space-x-3 text-gray-500 py-2"
            >
              <div class="flex space-x-1">
                <div
                  class="w-2 h-2 bg-lala-red rounded-full animate-bounce"
                  style="animation-delay: 0ms"
                ></div>
                <div
                  class="w-2 h-2 bg-lala-red rounded-full animate-bounce"
                  style="animation-delay: 150ms"
                ></div>
                <div
                  class="w-2 h-2 bg-lala-red rounded-full animate-bounce"
                  style="animation-delay: 300ms"
                ></div>
              </div>
              <span class="text-sm italic">Escribiendo...</span>
            </div>

            <!-- Clarification Suggestions -->
            <div
              *ngIf="message.needs_clarification && !isMessageLoading(i)"
              class="space-y-3"
            >
              <p class="text-sm text-gray-700">{{ message.interpretation }}</p>
              <div
                class="space-y-2"
                *ngIf="
                  message.suggested_queries &&
                  message.suggested_queries.length > 0
                "
              >
                <h5
                  class="text-xs font-medium text-gray-600 uppercase tracking-wide"
                >
                  Consultas sugeridas:
                </h5>
                <div class="space-y-2">
                  <button
                    *ngFor="let suggestion of message.suggested_queries"
                    class="block w-full text-left p-2 bg-white hover:bg-gray-50 border border-gray-200 hover:border-lala-red rounded-lg transition-colors duration-200"
                    (click)="sendSuggestedQuestion(suggestion)"
                  >
                    <span class="text-sm text-gray-700">{{ suggestion }}</span>
                  </button>
                </div>
              </div>
            </div>

            <!-- 🚀 NUEVO: Respuesta RAG de Políticas -->
            <div *ngIf="hasRAGResponse(message)" class="space-y-3">
              <!-- Advertencia de baja relevancia -->
              <div
                *ngIf="message.relevance_warning"
                class="bg-yellow-50 border border-yellow-200 rounded-lg p-3 mb-3"
              >
                <div class="flex items-center space-x-2">
                  <svg
                    class="w-4 h-4 text-yellow-600"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                    ></path>
                  </svg>
                  <span class="text-sm text-yellow-800 font-medium">{{
                    message.relevance_warning
                  }}</span>
                </div>
              </div>

              <!-- Respuesta con markdown renderizado -->
              <div class="prose prose-sm max-w-none">
                <div
                  class="text-sm text-gray-700"
                  [innerHTML]="renderMarkdown(message.answer || '')"
                ></div>
              </div>

              <!-- Información de la política (responsable / archivo) -->
              <div *ngIf="hasPolicyDetails(message)" class="mt-4 space-y-2">
                <div
                  *ngFor="let detail of message.policy_details"
                  class="bg-blue-50 border border-blue-200 rounded-lg p-3"
                >
                  <p class="text-sm font-semibold text-blue-900 mb-2">
                    {{ detail.policy_name }}
                  </p>
                  <div class="flex flex-wrap gap-x-6 gap-y-1">
                    <div
                      *ngIf="detail.responsable"
                      class="flex items-center space-x-2 text-sm text-blue-800"
                    >
                      <svg
                        class="w-4 h-4 text-blue-600 flex-shrink-0"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                        ></path>
                      </svg>
                      <span
                        ><strong>Responsable:</strong>
                        {{ detail.responsable }}</span
                      >
                    </div>
                    <div
                      *ngIf="detail.archivo"
                      class="flex items-center space-x-2 text-sm text-blue-800"
                    >
                      <svg
                        class="w-4 h-4 text-blue-600 flex-shrink-0"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z"
                        ></path>
                      </svg>
                      <a
                        [href]="detail.archivo"
                        target="_blank"
                        rel="noopener noreferrer"
                        class="text-blue-700 hover:text-blue-900 underline"
                      >
                        Ver documento
                      </a>
                    </div>
                  </div>
                  <p
                    *ngIf="detail.archivo"
                    class="text-xs text-blue-500 mt-1 flex items-center space-x-1"
                  >
                    <svg
                      class="w-3 h-3 flex-shrink-0"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
                      ></path>
                    </svg>
                    <span
                      >Solo accesible dentro de la red corporativa de Lala</span
                    >
                  </p>
                  <!-- Advertencia de política vencida -->
                  <div
                    *ngIf="detail.is_expired === 'true'"
                    class="mt-2 p-2 bg-amber-50 border border-amber-300 rounded text-xs text-amber-800 flex items-start space-x-2"
                  >
                    <svg
                      class="w-4 h-4 text-amber-500 flex-shrink-0 mt-0.5"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4.5c-.77-.833-2.694-.833-3.464 0L3.34 16.5c-.77.833.192 2.5 1.732 2.5z"
                      ></path>
                    </svg>
                    <span
                      ><strong>Documento vencido:</strong> Verifique con el área
                      responsable antes de tomar decisiones con base en este
                      contenido.</span
                    >
                  </div>
                </div>
              </div>

              <!-- Citaciones -->
              <div *ngIf="hasCitations(message)" class="mt-4">
                <button
                  class="flex items-center space-x-2 text-xs text-blue-600 hover:text-blue-800 font-medium"
                  (click)="toggleCitationsVisibility(i)"
                >
                  <svg
                    class="w-4 h-4 transform transition-transform"
                    [class.rotate-180]="citationsExpanded[i]"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M19 9l-7 7-7-7"
                    ></path>
                  </svg>
                  <span
                    >📚 Ver {{ message.citations?.length }} fuente(s)
                    consultada(s)</span
                  >
                </button>

                <div
                  *ngIf="citationsExpanded[i]"
                  class="mt-4 grid grid-cols-1 md:grid-cols-2 gap-3"
                >
                  <div
                    *ngFor="let citation of message.citations"
                    class="bg-white border border-gray-100 rounded-xl p-3 shadow-sm hover:shadow-md transition-all duration-200 cursor-default border-l-4 {{
                      getCitationRelevanceClass(citation)
                    }}"
                  >
                    <div class="flex items-start space-x-3">
                      <div class="p-2 bg-gray-50 rounded-lg">
                        <svg
                          class="w-4 h-4 text-lala-red"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                          ></path>
                        </svg>
                      </div>
                      <div class="flex-1 min-w-0">
                        <p class="text-sm font-semibold text-gray-900 truncate">
                          {{ citation.policy_name }}
                        </p>
                        <p class="text-xs text-gray-500 mt-0.5">
                          Sección:
                          {{ citation.section_number || citation.section }}
                          <span *ngIf="citation.section_name">
                            - {{ citation.section_name }}</span
                          >
                        </p>

                        <!-- Fragmento citado expandible -->
                        <details *ngIf="citation.original_text" class="mt-2">
                          <summary
                            class="text-xs text-blue-600 cursor-pointer hover:text-blue-800"
                          >
                            📄 Ver fragmento citado
                          </summary>
                          <p
                            class="mt-2 text-xs text-gray-600 bg-gray-50 p-2 rounded border-l-2 border-blue-300 italic"
                          >
                            "{{ citation.original_text }}"
                          </p>
                        </details>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- ADR-016: Opciones de desambiguación (cuando hay múltiples políticas) -->
              <div
                *ngIf="
                  message.disambiguation_options &&
                  message.disambiguation_options.length > 0 &&
                  !isMessageLoading(i)
                "
                class="mt-4 pt-3 border-t border-gray-100"
              >
                <p class="text-xs font-medium text-gray-500 mb-2">
                  Selecciona una opción:
                </p>
                <div class="flex flex-wrap gap-2">
                  <button
                    *ngFor="let option of message.disambiguation_options"
                    class="text-sm px-4 py-2 bg-blue-50 hover:bg-lala-red hover:text-white text-blue-700 rounded-lg border border-blue-200 hover:border-lala-red transition-colors duration-200 font-medium"
                    (click)="selectDisambiguationOption(option)"
                  >
                    {{ option.label }}
                  </button>
                </div>
              </div>

              <!-- Sugerencias dinámicas después de la respuesta RAG -->
              <div
                *ngIf="
                  message.suggested_queries &&
                  message.suggested_queries.length > 0 &&
                  !isMessageLoading(i) &&
                  !message.disambiguation_options
                "
                class="mt-4 pt-3 border-t border-gray-100"
              >
                <p class="text-xs font-medium text-gray-500 mb-2">
                  Preguntas relacionadas:
                </p>
                <div class="flex flex-wrap gap-2">
                  <button
                    *ngFor="let suggestion of message.suggested_queries"
                    class="text-sm px-3 py-1.5 bg-gray-50 hover:bg-lala-red hover:text-white text-gray-700 rounded-full border border-gray-200 hover:border-lala-red transition-colors duration-200"
                    (click)="sendSuggestedQuestion(suggestion)"
                  >
                    {{ suggestion }}
                  </button>
                </div>
              </div>

              <!-- Hint de uso -->
              <div
                *ngIf="message.usage_hint && !isMessageLoading(i)"
                class="mt-3 pt-2 border-t border-gray-50"
              >
                <p class="text-xs text-gray-400 italic">
                  <span class="font-medium">Tip:</span> {{ message.usage_hint }}
                </p>
              </div>
            </div>
          </div>

          <!-- Regular Response (Legacy SQL) -->
          <div
            *ngIf="hasValidResponse(message) && !hasRAGResponse(message)"
            class="space-y-3"
          >
            <!-- Query Analysis Badges -->
            <div
              *ngIf="message.query_analysis"
              class="flex items-center space-x-2 mb-3"
            >
              <span
                *ngIf="getQueryTypeBadge(message)"
                class="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-blue-100 text-blue-800"
              >
                {{ getQueryTypeBadge(message) }}
              </span>
              <span
                *ngIf="getComplexityBadge(message)"
                class="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-purple-100 text-purple-800"
              >
                {{ getComplexityBadge(message) }}
              </span>
              <span
                *ngIf="
                  message.query_analysis.entities &&
                  message.query_analysis.entities.brands &&
                  message.query_analysis.entities.brands.length > 0
                "
                class="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800"
              >
                🏢
                {{ message.query_analysis.entities.brands.length }} marca(s)
              </span>
              <span
                *ngIf="
                  message.query_analysis.entities &&
                  message.query_analysis.entities.models &&
                  message.query_analysis.entities.models.length > 0
                "
                class="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-yellow-100 text-yellow-800"
              >
                🚗
                {{ message.query_analysis.entities.models.length }} modelo(s)
              </span>
            </div>

            <!-- Interpretation -->
            <div class="prose prose-sm max-w-none">
              <p class="text-sm text-gray-700 whitespace-pre-wrap">
                {{ getCompleteInterpretation(message) }}
              </p>
            </div>

            <!-- 🚀 NUEVO: Context Applied Info -->
            <div
              *ngIf="hasContextApplied(message)"
              class="bg-blue-50 border border-blue-200 rounded-lg p-3 mb-3"
            >
              <button
                class="flex items-center space-x-2 text-xs text-blue-600 hover:text-blue-800 w-full"
                (click)="toggleContextVisibility(i)"
              >
                <svg
                  class="w-3 h-3 transform transition-transform"
                  [class.rotate-180]="contextVisible[i]"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M19 9l-7 7-7-7"
                  ></path>
                </svg>
                <span class="font-medium">IA aplicó contexto automático</span>
              </button>
              <div
                *ngIf="contextVisible[i] && message.context_applied"
                class="mt-2 space-y-1"
              >
                <div
                  *ngIf="message.context_applied.temporal"
                  class="text-xs text-blue-700"
                >
                  🕒 <strong>Contexto temporal:</strong>
                  {{ message.context_applied.temporal }}
                </div>
                <div
                  *ngIf="message.context_applied.auto_mapped_brands"
                  class="text-xs text-blue-700"
                >
                  🤖 <strong>Auto-mapeo:</strong>
                  {{ message.context_applied.auto_mapped_brands }}
                </div>
                <div
                  *ngIf="message.context_applied.correction"
                  class="text-xs text-blue-700"
                >
                  ✅ <strong>Corrección:</strong>
                  {{ message.context_applied.correction }}
                </div>
              </div>
            </div>

            <!-- Data Visualization Controls -->
            <div
              *ngIf="
                message.query_results &&
                message.query_results.row_count > 0 &&
                !isNoResultsMessage(message)
              "
              class="flex items-center justify-between bg-gray-50 px-4 py-2 rounded-lg"
            >
              <h4 class="text-sm font-medium text-gray-700">
                Datos ({{ message.query_results.row_count }} registros)
              </h4>
              <div class="flex items-center space-x-2">
                <!-- Chart/Table Toggle -->
                <div
                  *ngIf="canShowChart(message)"
                  class="flex items-center space-x-2"
                >
                  <button
                    class="flex items-center space-x-1 px-3 py-1 rounded-md text-xs font-medium transition-colors duration-200"
                    [class.bg-lala-red]="viewMode[i] === 'table'"
                    [class.text-white]="viewMode[i] === 'table'"
                    [class.bg-gray-200]="viewMode[i] !== 'table'"
                    [class.text-gray-700]="viewMode[i] !== 'table'"
                    (click)="viewMode[i] = 'table'"
                  >
                    <svg
                      class="w-3 h-3"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M3 10h18M3 14h18M3 18h18M3 6h18"
                      ></path>
                    </svg>
                    <span>Tabla</span>
                  </button>
                  <button
                    class="flex items-center space-x-1 px-3 py-1 rounded-md text-xs font-medium transition-colors duration-200"
                    [class.bg-lala-red]="viewMode[i] === 'chart'"
                    [class.text-white]="viewMode[i] === 'chart'"
                    [class.bg-gray-200]="viewMode[i] !== 'chart'"
                    [class.text-gray-700]="viewMode[i] !== 'chart'"
                    (click)="toggleViewMode(i)"
                  >
                    <svg
                      class="w-3 h-3"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
                      ></path>
                    </svg>
                    <span>Gráfico</span>
                  </button>
                </div>
              </div>
            </div>

            <!-- Chart View -->
            <div
              *ngIf="
                message.query_results &&
                message.query_results.row_count > 0 &&
                viewMode[i] === 'chart' &&
                !isNoResultsMessage(message)
              "
              class="mt-4"
            >
              <div class="bg-white rounded-lg border border-gray-200 p-4">
                <div class="h-80">
                  <canvas [id]="'chart-' + i"></canvas>
                </div>
              </div>
            </div>

            <!-- Table View -->
            <div
              *ngIf="
                message.query_results &&
                message.query_results.row_count > 0 &&
                viewMode[i] === 'table' &&
                !isNoResultsMessage(message)
              "
              class="mt-4"
            >
              <div
                class="bg-white rounded-lg border border-gray-200 overflow-hidden"
              >
                <div class="overflow-x-auto">
                  <table class="min-w-full divide-y divide-gray-200">
                    <thead class="bg-gray-50">
                      <tr>
                        <th
                          *ngFor="let column of message.query_results.columns"
                          class="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                        >
                          {{ column }}
                        </th>
                      </tr>
                    </thead>
                    <tbody class="bg-white divide-y divide-gray-200">
                      <tr
                        *ngFor="
                          let row of message.query_results.data;
                          let rowIndex = index
                        "
                        [class.bg-gray-50]="rowIndex % 2 === 0"
                      >
                        <td
                          *ngFor="let column of message.query_results.columns"
                          class="px-4 py-2 whitespace-nowrap text-sm text-gray-900"
                        >
                          {{ formatCellValue(row[column]) }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <!-- SQL Query (Collapsible) -->
            <div *ngIf="message.sql_query" class="mt-3">
              <button
                class="flex items-center space-x-2 text-xs text-gray-500 hover:text-gray-700"
                (click)="toggleSqlVisibility(i)"
              >
                <svg
                  class="w-4 h-4 transform transition-transform"
                  [class.rotate-180]="sqlVisible[i]"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M19 9l-7 7-7-7"
                  ></path>
                </svg>
                <span>Ver consulta SQL generada por IA</span>
                <!-- 🚀 NUEVO: Indicador de SQL avanzado -->
                <span
                  *ngIf="
                    message.sql_query.includes('WITH ') ||
                    message.sql_query.includes('OVER(')
                  "
                  class="inline-flex items-center px-1 py-0.5 rounded text-xs font-medium bg-purple-100 text-purple-800"
                >
                  SQL Avanzado
                </span>
              </button>
              <div
                *ngIf="sqlVisible[i]"
                class="mt-2 bg-gray-900 text-green-400 p-3 rounded-lg overflow-x-auto"
              >
                <pre class="text-xs whitespace-pre-wrap">{{
                  message.sql_query
                }}</pre>
              </div>
            </div>
          </div>

          <!-- Error State -->
          <div
            *ngIf="isMessageError(message)"
            class="text-sm text-red-600 bg-red-50 p-3 rounded-lg border border-red-200"
          >
            <div class="flex items-center space-x-2">
              <svg
                class="w-4 h-4 text-red-500"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                ></path>
              </svg>
              <span class="font-medium">Error en el análisis</span>
            </div>
            <p class="mt-1">
              {{
                message.error_details ||
                  "Lo siento, ocurrió un error al procesar tu consulta."
              }}
            </p>
            <button
              class="mt-2 text-xs text-red-600 hover:text-red-800 underline"
              (click)="sendSuggestedQuestion(message.user_message)"
            >
              Reintentar consulta
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="border-t border-gray-100 bg-gray-50 p-6">
    <!-- Input Container -->
    <div class="max-w-6xl mx-auto">
      <div
        class="bg-white rounded-2xl border border-gray-100 shadow-lg hover:shadow-xl transition-all duration-300 ring-1 ring-black ring-opacity-5"
      >
        <div class="flex items-end p-4 space-x-3">
          <!-- Action Buttons Left -->
          <div class="flex items-center space-x-2">
            <!-- Attach Button -->
            <!-- <button class="p-2 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-lg transition-colors duration-200"
                      title="Adjuntar archivo">
                <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" 
                        d="M12 6v6m0 0v6m0-6h6m-6 0H6"></path>
                </svg>
              </button> -->

            <!-- Options Button -->
            <!-- <button class="p-2 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-lg transition-colors duration-200"
                      title="Opciones">
                <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" 
                        d="M12 5v.01M12 12v.01M12 19v.01M12 6a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2z"></path>
                </svg>
              </button>
               -->
            <!-- History Button -->
            <!-- <button class="p-2 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-lg transition-colors duration-200"
                      title="Historial">
                <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" 
                        d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                </svg>
              </button> -->
          </div>

          <!-- Text Input -->
          <div class="flex-1">
            <textarea
              [(ngModel)]="currentMessage"
              (keydown)="onKeyDown($event)"
              (input)="autoResize($event)"
              placeholder="Responder..."
              class="w-full resize-none border-0 focus:ring-0 focus:outline-none text-gray-700 placeholder-gray-400 bg-transparent"
              rows="1"
              style="min-height: 24px; max-height: 300px"
              [disabled]="isLoading"
              #textareaRef
            ></textarea>
          </div>

          <!-- Model Selector -->
          <div class="flex items-center space-x-3">
            <!-- <div class="flex items-center space-x-2 text-sm text-gray-500">
                <span class="font-medium">Lala AI</span>
                <span class="text-xs bg-gray-100 px-2 py-1 rounded-full">v4.5</span>
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
                </svg>
              </div> -->

            <!-- Send Button -->
            <button
              (click)="sendMessage()"
              [disabled]="!currentMessage.trim() || isLoading"
              class="p-2 bg-[#C8102E] hover:bg-red-700 disabled:opacity-50 disabled:cursor-not-allowed text-white rounded-lg transition-all duration-200 hover:scale-105 disabled:hover:scale-100"
            >
              <img
                *ngIf="!isLoading"
                class="w-5 h-5 filter brightness-0 invert"
                src="send.svg"
                alt="Enviar mensaje"
              />
              <svg
                *ngIf="isLoading"
                class="w-5 h-5 animate-spin"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
                ></path>
              </svg>
            </button>
          </div>
        </div>
      </div>

      <!-- Footer Info -->
      <div
        class="mt-3 flex items-center justify-center space-x-2 text-xs text-gray-500"
      >
        <span class="font-medium">Powered by</span>
        <img
          src="logoxaldigitalgris_02.svg"
          alt="XalDigital"
          class="h-4 w-auto opacity-80"
        />
      </div>
    </div>
  </div>
</div>

<!-- 🌍 Selector de Región Modal -->
<div
  *ngIf="showRegionSelector"
  class="fixed inset-0 z-50 overflow-y-auto"
  aria-labelledby="modal-title"
  role="dialog"
  aria-modal="true"
>
  <div
    class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0"
  >
    <!-- Overlay de fondo -->
    <div
      class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
      aria-hidden="true"
      (click)="showRegionSelector = false"
    ></div>

    <span
      class="hidden sm:inline-block sm:align-middle sm:h-screen"
      aria-hidden="true"
      >&#8203;</span
    >

    <div
      class="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6"
    >
      <div class="sm:flex sm:items-start">
        <div
          class="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10"
        >
          <!-- Icono de Mundo/Región -->
          <svg
            class="h-6 w-6 text-lala-red"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
        </div>
        <div class="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left w-full">
          <h3
            class="text-lg leading-6 font-medium text-gray-900"
            id="modal-title"
          >
            Selecciona tu Región
          </h3>
          <div class="mt-2">
            <p class="text-sm text-gray-500">
              Para mostrarte las políticas correctas, por favor indica en qué
              región te encuentras:
            </p>
          </div>

          <!-- Opciones de Región -->
          <div class="mt-5 grid grid-cols-1 gap-3 sm:grid-cols-2">
            <button
              *ngFor="let region of availableRegions"
              (click)="onRegionSelected(region.code)"
              class="relative rounded-lg border border-gray-300 bg-white px-6 py-4 shadow-sm flex items-center space-x-3 hover:border-lala-red hover:ring-1 hover:ring-lala-red focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-lala-red transition-all duration-200"
            >
              <div class="flex-shrink-0 text-2xl">
                {{ region.flag }}
              </div>
              <div class="flex-1 min-w-0">
                <span class="absolute inset-0" aria-hidden="true"></span>
                <p class="text-sm font-medium text-gray-900">
                  {{ region.label }}
                </p>
              </div>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
